// Maps app routes to the RBAC permission required to see the nav item and open
// the page. A user whose role lacks the permission won't see the menu item and
// is redirected away if they hit the URL directly. Routes not listed here are
// open to any signed-in user (e.g. Home, Quick Start, Help, profile).
export const PATH_PERMISSIONS = {
  '/dashboards': 'reports:read',
  '/reports': 'reports:read',
  '/quickstart': 'quickstart:read',
  '/ai-copilot': 'ai_copilot:use',
  '/ai-coverage': 'ai_copilot:use',
  '/ai-insights': 'ai_insights:read',
  '/investigations': 'investigations:read',
  '/executive-summaries': 'executive_summaries:read',
  '/morning-brief': 'ai_insights:read',
  '/threads': 'discussions:read',
  '/discussions': 'discussions:read',
  '/activity': 'discussions:read',
  // Decisions area (placeholder gate, matches sibling items)
  '/initiatives': 'glossary:read',
  '/objectives': 'glossary:read',
  '/visual-library': 'visual_library:read',
  '/kpi-monitor': 'kpi:read',
  '/apps': 'apps:read',
  '/marketplace': 'marketplace:read',
  '/data-sources': 'data_sources:write',
  '/data-prep': 'data_prep:read',
  '/semantic-models': 'semantic_models:write',
  '/glossary': 'glossary:read',
  '/change-requests': 'change_requests:read',
  '/lineage-explorer': 'lineage:read',
  '/scheduling': 'schedules:read',
  '/alerts': 'alerts:read',
  '/anomaly-scans': 'anomaly:read',
  '/forecast-sentinels': 'forecast_sentinels:read',
  '/developers': 'embed:read',
  '/developer-docs': 'embed:read',
  '/sdk/visuals': 'embed:read',
  '/sdk/connectors': 'embed:read',
  '/embed-manager': 'embed:manage',

  // Governed Recommendations area
  '/my-work': 'glossary:read',
  '/decision-policies': 'glossary:read',
  '/notifications': 'glossary:read',
  '/results': 'glossary:read',
  '/admin/retention-preview': 'glossary:read',
  '/recommendations': 'recommendations:view',
  '/admin/recommendation-approvals': 'recommendations:approve',
  '/admin/recommendations': 'recommendations:rules_manage',

  // Governance area
  '/governance': 'governance:view',
  '/admin/adoption-analytics': 'governance:view',
  '/admin/certification-queue': 'measures:certify',
  '/admin/metric-registry': 'governance:view',
  '/admin/calculation-packs': 'semantic_models:read',
  '/admin/data-quality': 'quality:view',
  '/lineage': 'governance:view',
  '/admin/catalog': 'catalog:read',
  '/admin/explore-eval': 'ai_quality:review',
  '/admin/explore-kpis': 'ai_quality:review',
  '/admin/pii-compliance': 'pii:review',

  // Investigations area
  '/admin/investigations-analytics': 'investigations:read',
  '/admin/scenario-simulator': 'scenarios:use',

  // Monitoring area
  '/admin/sentinels': 'monitoring:view',
  '/admin/sentinel-packs': 'monitoring:view',
  '/admin/incidents': 'incidents:read',
  '/admin/risk-signals': 'monitoring:view',
  '/admin/drift-alerts': 'monitoring:view',
  '/admin/predictive-models': 'predictive:read',

  // Workspace Administration
  '/administration': 'users:read',
  '/access-control': 'roles:read',
  '/admin/usage-billing': 'users:read',

  // Platform Console (Cloverleaf super-admin only)
  '/platform-console': 'platform:operations',
  '/platform-admin': 'platform:operations',
  '/admin/status': 'platform:operations',
  '/admin/deploy-status': 'platform:operations',
  '/admin/jobs': 'platform:operations',
  '/admin/all-schedules': 'platform:operations',
  '/system-logs': 'platform:operations',
  '/admin/tenants': 'platform:customers',
  '/admin/signup-requests': 'platform:customers',
  '/admin/signup-invites': 'platform:customers',
  '/admin/trial-leads': 'platform:customers',
  '/admin/revenue': 'platform:commercial',
  '/admin/version-control': 'platform:engineering',
  '/admin/git-backup': 'users:write',
  '/admin/ai-traces': 'platform:engineering',
  '/admin/feature-flags': 'platform:engineering',
};

// Longest-prefix match so nested routes (e.g. /marketplace/abc) inherit the
// parent's requirement.
export function permForPath(pathname) {
  if (!pathname) return null;
  let best = null;
  for (const key of Object.keys(PATH_PERMISSIONS)) {
    if ((pathname === key || pathname.startsWith(key + '/')) && (!best || key.length > best.length)) {
      best = key;
    }
  }
  return best ? PATH_PERMISSIONS[best] : null;
}
